/*
 * facecloud后台index页面
 * @Author: ljb
 * @Date: 2018-03-26 10:18:23
 * @Last Modified by: ljb
 * @Last Modified time: 2020-01-21 10:02:19
 */
<style lang="less" rel="stylesheet/less" type="text/less">
.nav-head {
  width: 100%;
  min-width: 1186px;
position: relative;
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
//   min-width: 1140px;
  .breadcrumb-area {
    padding: 10px;
    position: absolute;
    line-height: 1;
        top: 10px;
        bottom: 0;
        left: 0;
        right: 200px;
     .breadcrumb{
         font-size: 18px;
     }

  }

  .drop-down {
      font-size: 16px;

      margin: 20px 30px 0 0;
   float: right;
    &.lang {
      margin-top: 12px;
    }
  }
}
</style>
<template>
	<div class="nav-head">
		<div class="breadcrumb-area">
			<Breadcrumb
				class="breadcrumb"
			>
				<BreadcrumbItem
					to="/home"
				>主页</BreadcrumbItem>
				<BreadcrumbItem
					v-for="item in breadList"
					:to="item.name"
                    :key="item.name"
                    >{{ item.name }}</BreadcrumbItem>

			</Breadcrumb>
		</div>
		<Dropdown
			class="drop-down"
			trigger="click"
			placement="bottom-end"
			@on-click="cancelLogin">
			<a
				href="javascript:void(0)"
				name="welcome">
				欢迎你,{{ user }}
				<Icon type="ios-arrow-down" />
			</a>

			<Dropdown-menu
				slot="list"
				style="min-width:170px;"
			>
				<Dropdown-item name="cancel">
					<a
						name="logout"
						href="javascript:void(0)">退出登录</a>
				</Dropdown-item>
			</Dropdown-menu>
		</Dropdown>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
       	user: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
		};
	},
	computed: {
		// 响应式获取vuex的getters,若刷新之后vuex数据丢失,获取的将是备份到的sessionStorage
		breadList() {

            var thct = this;

            var title_ = false;

            var data_ =[{
                name:''
            }]
            
             return thct.$store.getters.breadcrumbList;
             
            // for(var i=0;i<thct.$router.options.routes[3].children.length;i++){
            //     if(thct.$router.options.routes[3].children[i].title_box){
            //         if(thct.$router.options.routes[3].children[i].name==thct.$store.getters.breadcrumbList[0].name){
            //             title_ =true;
            //                data_[0].name=thct.$router.options.routes[3].children[i].title_box.title;
            //             return  data_;
            //         }

            //     }

            // }

            // if(!title_){
            //     return thct.$store.getters.breadcrumbList;
            // }



		},
	},
	watch: {
		// 监听回到home路由时 把除home外的面包屑都清除掉
		  $route(to) {
			  console.log("99999999999999")
			if (to.path == '/home' || to.path == '/home/') {
				this.$store.commit('deleteList');
				sessionStorage.removeItem('breadcrumbList');
			 }
		},
	},
	methods: {
		// 退出登录 回退到login页面并clear掉所有sessionStorage
		cancelLogin() {
			sessionStorage.clear('breadcrumbList');
			 this.$router.push({
				name: 'login',
			});
		},

	},
};
</script>
